import React from 'react';
import FormModal from "../../../components/common/modals/FormModal";
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {allEthnicitiesDropdown, allGendersDropdown, allProfessionalDesignationDropdown} from "../../../relay/Fragments";
import {createOptions, yesNoUnknownOptions} from "../../../helpers/utils";
import dayjs from "dayjs";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import HorizontalFormCheck from "../../../components/common/horizontal-form-inputs/HorizontalFormCheck";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import {bandedSchema} from "../../../helpers/bandedUtils";

const EditFacilityVersionModal = ({showModal, onClose, selectedVersion}) => {
    const mutation = graphql`
    mutation EditFacilityVersionModalMutation($id: ID!, $name: String!, $nickName: String!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
        facility {
            modifyVersion(input: {facilityVersionId: $id, name: $name, nickname: $nickName,
            effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                facilityVersion {
                    id
                    facility {
                      versions {
                          ...FacilityVersions_Versions
                      }
                        applicableVersion {
                            id
                        }}}}}}`
    const [commitMutation, isInFlight] = useMutation(mutation);
    const effectiveFrom = selectedVersion?.effectiveFrom ? dayjs(selectedVersion?.effectiveFrom).toDate() : '';
    const effectiveTo = selectedVersion?.effectiveTo ? dayjs(selectedVersion?.effectiveTo).toDate() : '';
    const defaultValues = {
        id: selectedVersion?.id,
        name: selectedVersion?.name,
        nickName: selectedVersion?.nickName,
        effectiveFrom: effectiveFrom,
        effectiveTo: effectiveTo
    }
    const schema = bandedSchema.shape({
        name: yup.string().required("Name is required")
    });
    const methods = useForm({values: defaultValues, resolver: yupResolver(schema)});
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.facility) {
                    toast.success("Version for Facility updated")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"Update Version"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
        >
            <HorizontalFormInput controlId={"name"} label={"Name"} />
            <HorizontalFormInput controlId={"nickName"} label={"Nick Name"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
EditFacilityVersionModal.defaultProps = {}
EditFacilityVersionModal.propTypes = {}
export default EditFacilityVersionModal